import { ReactElement } from "react";
import { Card } from "@pushpress/shared-components";
import styles from "./InfoModalCard.module.scss";

const InfoModalCard = ({
  children,
}: {
  children: ReactElement | ReactElement[];
}) => {
  return (
    <Card size="lg" className={styles.root}>
      {children}
    </Card>
  );
};

export default InfoModalCard;
